import { ChartView } from '@/features/ai-agents/chat/MarkdownTableVisualization/types';

export const CHART_COLOR = `#1779F7`;

export const CHART_SERIES_COLORS = [
  `#1779F7`,
  `#D18BFF`,
  `#F1B8B6`,
  `#6FA8A1`,
  `#A9C8F2`,
  `#F4C96B`,
  `#8FD3C7`,
  `#B7A6E8`,
  `#F3A66A`,
  `#9DB4C0`,
];

export const TITLE_FONT_FAMILY = `Eesti, sans-serif`;
export const DATA_FONT_FAMILY = `Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`;

export const TABLE_COLUMN_MIN_WIDTH = `15rem`;
export const TABLE_COLUMN_MAX_WIDTH = `24rem`;

export const CHART_VIEWS: { label: string; value: ChartView }[] = [
  { label: `Line`, value: `line` },
  { label: `Bar`, value: `bar` },
  { label: `Pie`, value: `pie` },
];
